import React from 'react';
import { createRoot } from 'react-dom/client';
import { ThemeProvider } from '@mui/material';
import CssBaseline from '@mui/material/CssBaseline';
import { BrowserRouter as Router } from 'react-router-dom';
import theme from 'src/styles/default-theme';
import { StyledEngineProvider } from '@mui/material/styles';
import { RootStoreProvider, rootStore } from 'src/stores/configureStore/configureStore';
import { browserHistoryInstance } from 'src/core/history';
import { amplitudeInit } from 'src/configs/amplitude';
import WorkPage from 'src/pages/WorkPage';
import { App } from 'src/app';
import './i18n';
const renderApplication = async () => {
  const technicalWorks = false;
  const rootElement = document.getElementById('root');
  const path = (/#!(\/.*)$/.exec(window.location.hash) || [])[1];
  amplitudeInit();
  if (path) {
    browserHistoryInstance.replace(path);
  }
  if (!technicalWorks) {
    await Promise.all([rootStore.account.getFeatureFlagsAsync.run({}, []), rootStore.properties.getServerCurrentTimeAsync.run({}, [])]);
  }
  try {
    if (!rootElement) throw new Error('Root element not found');
    const root = createRoot(rootElement);
    root.render(/*#__PURE__*/React.createElement(Router, {
      history: browserHistoryInstance
    }, /*#__PURE__*/React.createElement(RootStoreProvider, {
      value: rootStore
    }, /*#__PURE__*/React.createElement(CssBaseline, null), /*#__PURE__*/React.createElement(StyledEngineProvider, {
      injectFirst: true
    }, /*#__PURE__*/React.createElement(ThemeProvider, {
      theme: theme
    }, technicalWorks ? /*#__PURE__*/React.createElement(WorkPage, null) : /*#__PURE__*/React.createElement(App, null))))));
  } catch (error) {
    if (!rootElement) throw error;
    const root = createRoot(rootElement);
    root.render(/*#__PURE__*/React.createElement(React.StrictMode, null, /*#__PURE__*/React.createElement("b", null, "We are sorry, but something went wrong while loading the app")));
    throw error;
  }
};
renderApplication();